import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  Typography,
  TextField,
  MenuItem,
  InputAdornment,
  Paper,
  IconButton,
  Chip,
  Divider,
} from "@mui/material";
import {
  useDeleteProductMutation,
  useGetProductQuery,
  useGetProductCategoryQuery,
  useGetProductBrandQuery,
  useGetProductTagQuery,
  useGetCategoryQuery,
  useGetAllMainCategoryQuery,
  useGetSubCategoryByArrayQuery,
} from "../../../Api/attoDeskApi";
import {
  ICategory,
  IProductBrand,
  IProductCategory,
  IProductPopUP,
  IProductTag,
} from "../../../Api/Interface/api.interface";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import { useNotifier } from "../../../Core/Notifier";
import { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import NewPopUpProduct from "../Edit/index";
import { useNavigate, Link } from "react-router-dom";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import Pagination from "../../../Components/Pagination";
import placeholderImage from '../../../Images/fav.png';
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import InventoryIcon from "@mui/icons-material/Inventory";
import axios from "axios";

const Index = () => {
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;
  const getFormattedDate = (createDate: Dayjs | null): string => {
    return createDate ? createDate.format("YYYY-MM-DD") : "";
  };
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [selectedProductBrandId, setSelectedProductBrandId] =
    useState<string>("");
  const [selectedProductCategoryId, setSelectedProductCategoryId] =
    useState<string>("");
  const [selectedProductTagIds, setSelectedProductTagIds] = useState<string[]>(
    []
  );
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [selectedProductViewOnline, setSelectedProductViewOnline] =
    useState<string>("");
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const startDateAsDate = startDate?.toDate() || null;
  const endDateAsDate = endDate?.toDate() || null;
  const [createDate, setCreateDate] = useState<Dayjs | null>(null);
  const [isPaperVisible, setIsPaperVisible] = useState(false);
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
  const [editingCell, setEditingCell] = useState<string | null>(null);
  const [editValue, setEditValue] = useState<string>("");

  const { data: categoryData } = useGetAllMainCategoryQuery({
    departmentId: "",
    coursingId: "",
    roleId: null,
    taxeId: "",
    createdDateStart: null,
    createdDateEnd: null,
    searchText: "",
    numberOfLength: 0,
    isActive: true,
    categoryIsLooping: null,
    createdDate: null,
  });

  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubCategoryId, setSelectedSubToSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubToSubCategoryId, setSelectedSubToSubToSubCategoryId] =
    useState<number | null>(null);

  const { data: subCategoryData, refetch: refetchSubCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedCategoryId ? [Number(selectedCategoryId)] : [],
    });

  const { data: subCategory2Data, refetch: refetchS2bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [Number(selectedCategoryId), Number(selectedSubCategoryId)]
        : [],
    });

  const { data: subCategory3Data, refetch: refetchS3bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [
            Number(selectedCategoryId),
            Number(selectedSubCategoryId),
            Number(selectedSubToSubCategoryId),
          ]
        : [],
    });
  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);

  const subCategoryList = useMemo(() => {
    return subCategoryData?.data as ICategory[];
  }, [subCategoryData?.data]);

  const subToSubCategoryList = useMemo(() => {
    return subCategory2Data?.data as ICategory[];
  }, [subCategory2Data?.data]);

  const subToSubToSubCategoryList = useMemo(() => {
    return subCategory3Data?.data as ICategory[];
  }, [subCategory3Data?.data]);

  const productCategoryId = selectedSubToSubToSubCategoryId
    ? Number(selectedSubToSubToSubCategoryId)
    : selectedSubToSubCategoryId
    ? Number(selectedSubToSubCategoryId)
    : selectedSubCategoryId
    ? Number(selectedSubCategoryId)
    : selectedCategoryId
    ? Number(selectedCategoryId)
    : String("");

 


  const { data, isLoading, isError, refetch } = useGetProductQuery({
    productBrandId: selectedProductBrandId,
    productCategoryId: String(productCategoryId),
    productTagIds: selectedProductTagIds,
    productViewOnline: selectedProductViewOnline,
    createdDateStart: startDateAsDate as Date,
    createdDateEnd: endDateAsDate as Date,
    searchText: currentSearchQuery,
    createdDate: getFormattedDate(createDate),
    id: null,
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [selectedProduct, setSelectedProduct] = useState<IProductPopUP | null>(
    null
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteProduct, setOpenDeleteProduct] = useState(false);
  const [productToDelete, setProductToDelete] = useState<IProductPopUP | null>(
    null
  );


  const { data: productBrandData, isLoading: productBrandLoading } =
    useGetProductBrandQuery({
      searchText: "",
      isActive: true,
    });
  const { data: coursingData, isLoading: coursingLoading } =
    useGetCategoryQuery();
  const { data: taxData, isLoading: taxLoading } = useGetProductTagQuery({
    searchText: "",
    isActive: true,
  });
  const { data: productCategoryData, isLoading: productCategoryLoading } =
    useGetProductCategoryQuery({
      searchText: "",
      isActive: true,
    });
  const { data: productTagData, isLoading: ProductTagLoading } =
    useGetProductTagQuery({
      searchText: "",
      isActive: true,
    });

  const productBrandList = useMemo(() => {
    return productBrandData?.data as IProductBrand[];
  }, [productBrandData?.data]);

  const coursingList = useMemo(() => {
    return coursingData?.data as ICategory[];
  }, [coursingData?.data]);

  const taxList = useMemo(() => {
    return taxData?.data as IProductTag[];
  }, [taxData?.data]);

  const productList = useMemo(() => {
    return productCategoryData?.data as IProductCategory[];
  }, [productCategoryData?.data]);

  const productTagList = useMemo(() => {
    return productTagData?.data as IProductTag[];
  }, [productTagData?.data]);

  const productBrandMap = useMemo(() => {
    const map = new Map();
    productBrandList?.forEach((brand) => {
      map.set(brand.id, brand.productBrandName);
    });
    return map;
  }, [productBrandList]);

  const coursingMap = useMemo(() => {
    const map = new Map();
    coursingList?.forEach((category) => {
      map.set(category.id, category.categoryName);
    });
    return map;
  }, [coursingList]);

  const parentCategoryMap = useMemo(() => {
    const map = new Map<number, string>();
    coursingList?.forEach((category) => {
      if (category.parent_ids && category.parent_ids.length > 0) {
        const parentId = category.parent_ids[0];
        const parentCat = coursingList.find((c) => c.id === parentId);
        if (parentCat) {
          map.set(category.id, parentCat.categoryName);
        }
      }
    });
    return map;
  }, [coursingList]);

  const taxMap = useMemo(() => {
    const map = new Map();
    taxList?.forEach((tag) => {
      map.set(tag.id, tag.tagName);
    });
    return map;
  }, [taxList]);

 

  const handleMainCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const categoryId = event.target.value as number;
    setSelectedCategoryId(categoryId);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);

    const selectedCategory = categoryList.find(
      (category) => category.id == categoryId
    );
  };

  const handleSubCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const subCategoryId = event.target.value as number;
    setSelectedSubCategoryId(subCategoryId);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);

    const selectedCategory = subCategoryList.find(
      (category) => category.id == subCategoryId
    );
  };

  const handleSubToSubCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const selectedSubToSubCategoryId = event.target.value as number;
    setSelectedSubToSubCategoryId(selectedSubToSubCategoryId);
    setSelectedSubToSubToSubCategoryId(null);

    const selectedCategory = subToSubCategoryList.find(
      (category) => category.id == selectedSubToSubCategoryId
    );
  };

  const handleSubToSubToSubCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const selectedSubToSubToSubCategoryId = event.target.value as number;
    setSelectedSubToSubToSubCategoryId(selectedSubToSubToSubCategoryId);

    const selectedCategory = subToSubToSubCategoryList.find(
      (category) => category.id == selectedSubToSubToSubCategoryId
    );
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (product: IProductPopUP) => {
    setSelectedProduct(product);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedProduct(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (product: IProductPopUP) => {
    setProductToDelete(product);
    setOpenDeleteProduct(true);
  };

  const handleCloseDeletePopup = () => {
    setProductToDelete(null);
    setOpenDeleteProduct(false);
  };

  const handleProductBrandChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProductBrandId(selectedValues);
  };

  const handleProductViewOnline = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProductViewOnline(selectedValues);
  };

  const handleProductCategory = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProductCategoryId(selectedValues);
  };

  const handleStartDateChange = (newValue: Dayjs | null) => {
    setStartDate(newValue);
  };

  const handleEndDateChange = (newValue: Dayjs | null) => {
    setEndDate(newValue);
  };

  const handleCreateDateChange = (newValue: Dayjs | null) => {
    setCreateDate(newValue);
  };

  const handleProductTag = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event;
    setSelectedProductTagIds(
      typeof value === "string" ? value.split(",") : value
    );
  };

  const [deleteCategory] = useDeleteProductMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteProduct(false);
      } else {
        showErrorMessage("Failed to delete the product");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the product");
    }
  };

  const handleToggle = () => {
    setIsPaperVisible(!isPaperVisible);
  };

const [isImporting, setIsImporting] = useState(false);

const downloadTemplate = async () => {
  try {
    const response = await fetch(`${API_URL}/products/template`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    });
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "product_template.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error(err);
    showErrorMessage("Failed to download template");
  }
};

const handleImport = async (e: React.ChangeEvent<HTMLInputElement>) => {
  if (!e.target.files?.length) return;
  const file = e.target.files[0];
  const formData = new FormData();
  formData.append("file", file);

  try {
    setIsImporting(true);
    const res = await fetch(`${API_URL}/products/import`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      },
      body: formData,
    });

    const data = await res.json();

    if (!res.ok) {
      showErrorMessage(data.message || "Import failed");
      return;
    }

    if (data.duplicates && data.duplicates.length > 0) {
      const duplicateList = data.duplicates
        .map((d: { row: number; productName: string }) => `Row ${d.row}: ${d.productName}`)
        .join("\n");
      showErrorMessage(
        `Imported ${data.inserted} products.\n\nDuplicate products skipped:\n${duplicateList}`
      );
    } else {
      showMessage(`${data.inserted} products imported successfully`);
    }

    refetch();
  } catch (err) {
    console.error(err);
    showErrorMessage("Import error. Please try again.");
  } finally {
    setIsImporting(false);
    e.target.value = "";
  }
};

const handleDoubleClick = (
  rowId: string | number,
  field: "salePrice" | "offerPrice" | "wholesaleprice",
  value: string | number | null | undefined
) => {
  setEditingCell(`${rowId}-${field}`);
  setEditValue(value ? String(value) : "");
};

const handleSaveInline = async (row: IProductPopUP, field: string) => {
  try {
    const payload = {
      productId: row.id,
      reg_price: field === "salePrice" ? editValue : row.salePrice,
      sale_price: field === "offerPrice" ? editValue : row.offerPrice,
      wholesale_price:
        field === "wholesaleprice" ? editValue : row.wholesaleprice,
    };

    await axios.post(`${API_URL}/save-manual-price`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      },
    });

    showMessage("Price updated successfully");
     refetch();

    setEditingCell(null);
  } catch (err) {
    console.error(err);
    showErrorMessage("Error updating price");
  }
};

  const selectSx = {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2, fontSize: 13, bgcolor: "#fff",
      "& fieldset": { borderColor: "#e2e8f0" },
      "&:hover fieldset": { borderColor: "#cbd5e1" },
      "&.Mui-focused fieldset": { borderColor: "#00838f", borderWidth: 1.5 },
    },
  };

  if (
    isLoading ||
    productBrandLoading ||
    coursingLoading ||
    taxLoading ||
    productCategoryLoading ||
    ProductTagLoading
  ) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="40vh">
        <CircularProgress sx={{ color: "#0f172a" }} />
      </Box>
    );
  }

  const coursings: IProductPopUP[] = Array.isArray(data?.data)
    ? (data?.data as IProductPopUP[])
    : [];

  const resetFields = () => {
    setSelectedProductBrandId("");
    setSelectedProductCategoryId("");
    setSelectedProductViewOnline("");
    setSelectedProductTagIds([]);
    setStartDate(null);
    setEndDate(null);
    setCreateDate(null);
    // setSelectedCategoryId(null);
    // setSelectedSubCategoryId(null);
    // setSelectedSubToSubCategoryId(null);
    // setSelectedSubToSubToSubCategoryId(null);
  };

  const handleAddProductClick = () => {
    navigate("/product/create");
  };

  return (
    <Box sx={{ bgcolor: "#f8f9fb", minHeight: "100vh" }}>
      {/* ── Top Bar ── */}
      <Box sx={{ bgcolor: "#fff", borderBottom: "1px solid #e2e8f0", px: 3, py: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mx: "auto" }}>
          <InventoryIcon sx={{ fontSize: 22, color: "#0f172a" }} />
          <Box sx={{ flex: 1 }}>
            <Typography fontSize={18} fontWeight={700} color="#0f172a" letterSpacing="-0.02em">Products</Typography>
            <Typography fontSize={12} color="#94a3b8">{coursings.length} total products</Typography>
          </Box>
          <TextField
            size="small"
            placeholder="Search by name or barcode..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: 18, color: "#94a3b8" }} />
                </InputAdornment>
              ),
            }}
            sx={{ width: 280, "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: 13, bgcolor: "#f8fafc", "& fieldset": { borderColor: "#e2e8f0" }, "&.Mui-focused fieldset": { borderColor: "#00838f", borderWidth: 1.5 } } }}
          />
          <Button variant="outlined" size="small" onClick={handleToggle}
            startIcon={<FilterListIcon sx={{ fontSize: 16 }} />}
            sx={{ borderRadius: 2, textTransform: "none", fontSize: 12, fontWeight: 600, borderColor: isPaperVisible ? "#00838f" : "#e2e8f0", color: isPaperVisible ? "#00838f" : "#64748b", bgcolor: isPaperVisible ? "#e0f7fa" : "transparent" }}>
            Filters
          </Button>
          <Divider orientation="vertical" flexItem />
          <Button variant="outlined" size="small" onClick={downloadTemplate}
            startIcon={<FileDownloadIcon sx={{ fontSize: 16 }} />}
            sx={{ borderRadius: 2, textTransform: "none", fontSize: 12, fontWeight: 600, borderColor: "#e2e8f0", color: "#64748b" }}>
            Template
          </Button>
          <Button variant="outlined" size="small" component="label" disabled={isImporting}
            startIcon={<FileUploadIcon sx={{ fontSize: 16 }} />}
            sx={{ borderRadius: 2, textTransform: "none", fontSize: 12, fontWeight: 600, borderColor: "#e2e8f0", color: "#64748b" }}>
            {isImporting ? "Importing..." : "Import"}
            <input type="file" hidden accept=".xlsx,.xls,.csv" onChange={handleImport} />
          </Button>
          <Button variant="contained" disableElevation size="small" onClick={handleAddProductClick}
            startIcon={<AddIcon sx={{ fontSize: 16 }} />}
            sx={{ borderRadius: 2, textTransform: "none", fontSize: 12, fontWeight: 700, bgcolor: "#0f172a", px: 2.5, "&:hover": { bgcolor: "#1e293b" } }}>
            Add Product
          </Button>
        </Box>
      </Box>

      {/* ── Content ── */}
      <Box sx={{ mx: "auto", p: 3 }}>

        {/* ── Category Filters ── */}
        <Paper elevation={0} sx={{ p: 2.5, mb: 2, borderRadius: 2.5, border: "1px solid #e2e8f0" }}>
          <Grid container spacing={2} alignItems="flex-end">
            <Grid item xs={12} sm={6} md={3} lg={2}>
              <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#64748b", mb: 0.75, textTransform: "uppercase", letterSpacing: "0.05em" }}>Main Category</Typography>
              <TextField select fullWidth size="small" value={selectedCategoryId || ""} onChange={handleMainCategoryChange} sx={selectSx}>
                <MenuItem value="Select an option" sx={{ color: "#94a3b8", fontSize: 13 }}>Select an option</MenuItem>
                {categoryList && categoryList.map((category) => (
                  <MenuItem key={category.id} value={category.id} sx={{ fontSize: 13 }}>{category.categoryName}</MenuItem>
                ))}
              </TextField>
            </Grid>
            {selectedCategoryId && subCategoryList?.length > 0 && (
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#64748b", mb: 0.75, textTransform: "uppercase", letterSpacing: "0.05em" }}>Sub Category</Typography>
                <TextField select fullWidth size="small" value={selectedSubCategoryId ?? ""} onChange={handleSubCategoryChange} sx={selectSx}>
                  <MenuItem value="" disabled sx={{ color: "#94a3b8", fontSize: 13 }}>Select an option</MenuItem>
                  {subCategoryList.map((sc) => (
                    <MenuItem key={sc.id} value={sc.id} sx={{ fontSize: 13 }}>{sc.categoryName}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
            {selectedCategoryId && selectedSubCategoryId && subToSubCategoryList?.length > 0 && (
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#64748b", mb: 0.75, textTransform: "uppercase", letterSpacing: "0.05em" }}>Sub-to-Sub Category</Typography>
                <TextField select fullWidth size="small" value={selectedSubToSubCategoryId ?? ""} onChange={handleSubToSubCategoryChange} sx={selectSx}>
                  <MenuItem value="" disabled sx={{ color: "#94a3b8", fontSize: 13 }}>Select an option</MenuItem>
                  {subToSubCategoryList.map((s) => (
                    <MenuItem key={s.id} value={s.id} sx={{ fontSize: 13 }}>{s.categoryName}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
            {selectedCategoryId && selectedSubCategoryId && selectedSubToSubCategoryId && subToSubToSubCategoryList?.length > 0 && (
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#64748b", mb: 0.75, textTransform: "uppercase", letterSpacing: "0.05em" }}>Sub-to-Sub-to-Sub</Typography>
                <TextField select fullWidth size="small" value={selectedSubToSubToSubCategoryId ?? ""} onChange={handleSubToSubToSubCategoryChange} sx={selectSx}>
                  <MenuItem value="" disabled sx={{ color: "#94a3b8", fontSize: 13 }}>Select an option</MenuItem>
                  {subToSubToSubCategoryList.map((s) => (
                    <MenuItem key={s.id} value={s.id} sx={{ fontSize: 13 }}>{s.categoryName}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
          </Grid>
        </Paper>

        {/* ── Advanced Filters (togglable) ── */}
        {isPaperVisible && (
          <Paper elevation={0} sx={{ p: 2.5, mb: 2, borderRadius: 2.5, border: "1px solid #e2e8f0" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
              <FilterListIcon sx={{ fontSize: 18, color: "#3b82f6" }} />
              <Typography fontSize={13} fontWeight={700} color="#0f172a">Advanced Filters</Typography>
            </Box>
            <Grid container spacing={2} alignItems="flex-end">
              <Grid item xs={12} sm={6} md={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#64748b", mb: 0.75, textTransform: "uppercase", letterSpacing: "0.05em" }}>Tag</Typography>
                <TextField select fullWidth size="small" SelectProps={{ multiple: true, native: false }} value={selectedProductTagIds || ""} onChange={handleProductTag} sx={selectSx}>
                  {productTagList && productTagList.length > 0 ? (
                    productTagList.map((pt: IProductTag) => (
                      <MenuItem key={pt.id} value={pt.id} sx={{ fontSize: 13 }}>{pt.tagName}</MenuItem>
                    ))
                  ) : (
                    <MenuItem value="" sx={{ color: "#94a3b8", fontSize: 13 }}>No tags</MenuItem>
                  )}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#64748b", mb: 0.75, textTransform: "uppercase", letterSpacing: "0.05em" }}>Brand</Typography>
                <TextField select fullWidth size="small" value={selectedProductBrandId || ""} onChange={handleProductBrandChange} sx={selectSx}>
                  <MenuItem value="" sx={{ color: "#94a3b8", fontSize: 13 }}>All Brands</MenuItem>
                  {productBrandList.map((pb) => (
                    <MenuItem key={pb.id} value={pb.id} sx={{ fontSize: 13 }}>{pb.productBrandName}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#64748b", mb: 0.75, textTransform: "uppercase", letterSpacing: "0.05em" }}>View Online</Typography>
                <TextField select fullWidth size="small" value={selectedProductViewOnline || ""} onChange={handleProductViewOnline} sx={selectSx}>
                  <MenuItem value="" sx={{ color: "#94a3b8", fontSize: 13 }}>All</MenuItem>
                  <MenuItem value="1" sx={{ fontSize: 13 }}>Yes</MenuItem>
                  <MenuItem value="0" sx={{ fontSize: 13 }}>No</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#64748b", mb: 0.75, textTransform: "uppercase", letterSpacing: "0.05em" }}>Create Date</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker onChange={handleCreateDateChange} value={createDate}
                    slotProps={{ textField: { size: "small", fullWidth: true, sx: selectSx } }} />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#64748b", mb: 0.75, textTransform: "uppercase", letterSpacing: "0.05em" }}>Start Date</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker onChange={handleStartDateChange} value={startDate}
                    slotProps={{ textField: { size: "small", fullWidth: true, sx: selectSx } }} />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#64748b", mb: 0.75, textTransform: "uppercase", letterSpacing: "0.05em" }}>End Date</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker onChange={handleEndDateChange} value={endDate}
                    slotProps={{ textField: { size: "small", fullWidth: true, sx: selectSx } }} />
                </LocalizationProvider>
              </Grid>
            </Grid>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button variant="outlined" size="small" startIcon={<RestartAltIcon sx={{ fontSize: 16 }} />} onClick={resetFields}
                sx={{ borderRadius: 2, textTransform: "none", fontSize: 12, fontWeight: 600, borderColor: "#e2e8f0", color: "#64748b" }}>
                Reset Filters
              </Button>
            </Box>
          </Paper>
        )}

        {/* ── Table ── */}
        <Paper elevation={0} sx={{ borderRadius: 2.5, border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: "#f8fafc" }}>
                  {["#", "Product", "Category", "Sub Category", "Cost", "Instore Price", "Wholesale Price", "Online", "Stock", "Actions"].map((header) => (
                    <TableCell key={header}
                      sx={{
                        fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em",
                        borderBottom: "1px solid #e2e8f0", py: 1.5, px: 2, whiteSpace: "nowrap",
                        ...(header === "Actions" ? { textAlign: "right" } : {}),
                      }}>
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {isError || coursings.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center" sx={{ py: 8, color: "#94a3b8", fontSize: 13 }}>
                      {isError ? "Error fetching data" : "No products found"}
                    </TableCell>
                  </TableRow>
                ) : (
                  coursings
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row: IProductPopUP, index) => (
                      <TableRow key={row.id} sx={{ "&:hover": { bgcolor: "#f8fafc" }, transition: "background 0.15s" }}>
                        {/* # */}
                        <TableCell sx={{ fontSize: 12, color: "#94a3b8", py: 1.5, px: 2, borderBottom: "1px solid #f1f5f9" }}>
                          {page * rowsPerPage + index + 1}
                        </TableCell>
                        {/* Product */}
                        <TableCell sx={{ py: 1.5, px: 2, borderBottom: "1px solid #f1f5f9" }}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                            <Box sx={{
                              width: 40, height: 40, borderRadius: 2, overflow: "hidden", flexShrink: 0,
                              border: "1px solid #f1f5f9", bgcolor: "#f8fafc",
                              display: "flex", alignItems: "center", justifyContent: "center",
                            }}>
                              <img
                                src={row.productImg ? `${LARAVEL_API_URL}/${row.productImg}` : placeholderImage}
                                alt=""
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                              />
                            </Box>
                            <Link to={`/product-history/${row.id}`} style={{ textDecoration: "none", color: "inherit" }}>
                              <Typography sx={{
                                fontSize: 13, fontWeight: 600, color: "#0f172a",
                                wordBreak: "break-word", display: "-webkit-box",
                                WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden",
                                "&:hover": { color: "#00838f" }, transition: "color 0.15s",
                              }}>
                                {row.productName?.charAt(0).toUpperCase() + row.productName?.slice(1)}
                              </Typography>
                            </Link>
                          </Box>
                        </TableCell>
                        {/* Category */}
                        <TableCell sx={{ fontSize: 12, color: "#334155", py: 1.5, px: 2, borderBottom: "1px solid #f1f5f9" }}>
                          {parentCategoryMap.get(row.productCategoryId) || coursingMap.get(row.productCategoryId) || "—"}
                        </TableCell>
                        {/* Sub Category */}
                        <TableCell sx={{ fontSize: 12, color: "#334155", py: 1.5, px: 2, borderBottom: "1px solid #f1f5f9", textTransform: "capitalize" }}>
                          {parentCategoryMap.has(row.productCategoryId) ? coursingMap.get(row.productCategoryId) || "—" : "—"}
                        </TableCell>
                        {/* Cost */}
                        <TableCell sx={{ fontSize: 12, fontWeight: 500, color: "#334155", py: 1.5, px: 2, borderBottom: "1px solid #f1f5f9" }}>
                          {row.productPrice ? `$${row.productPrice}` : "—"}
                        </TableCell>
                        {/* Instore Price */}
                        <TableCell
                          sx={{ fontSize: 12, fontWeight: 500, color: "#334155", py: 1.5, px: 2, borderBottom: "1px solid #f1f5f9", cursor: "pointer" }}
                          onDoubleClick={() => handleDoubleClick(row.id, "salePrice", row.salePrice)}
                        >
                          {editingCell === `${row.id}-salePrice` ? (
                            <TextField size="small" value={editValue} onChange={(e) => setEditValue(e.target.value)}
                              onBlur={() => handleSaveInline(row, "salePrice")} autoFocus
                              sx={{ width: 90, "& .MuiOutlinedInput-root": { fontSize: 12, borderRadius: 1.5 } }} />
                          ) : row.salePrice ? `$${row.salePrice}` : "—"}
                        </TableCell>
                        {/* Wholesale Price */}
                        <TableCell
                          sx={{ fontSize: 12, fontWeight: 500, color: "#334155", py: 1.5, px: 2, borderBottom: "1px solid #f1f5f9", cursor: "pointer" }}
                          onDoubleClick={() => handleDoubleClick(row.id, "wholesaleprice", row.wholesaleprice)}
                        >
                          {editingCell === `${row.id}-wholesaleprice` ? (
                            <TextField size="small" value={editValue} onChange={(e) => setEditValue(e.target.value)}
                              onBlur={() => handleSaveInline(row, "wholesaleprice")} autoFocus
                              sx={{ width: 90, "& .MuiOutlinedInput-root": { fontSize: 12, borderRadius: 1.5 } }} />
                          ) : row.wholesaleprice ? `$${row.wholesaleprice}` : "—"}
                        </TableCell>
                        {/* Online */}
                        <TableCell sx={{ py: 1.5, px: 2, borderBottom: "1px solid #f1f5f9" }}>
                          <Chip
                            size="small"
                            icon={row.productViewPos ? <CheckIcon sx={{ fontSize: 14 }} /> : <CloseIcon sx={{ fontSize: 14 }} />}
                            label={row.productViewPos ? "Yes" : "No"}
                            sx={{
                              height: 24, fontSize: 11, fontWeight: 600,
                              bgcolor: row.productViewPos ? "#f0fdf4" : "#fef2f2",
                              color: row.productViewPos ? "#16a34a" : "#dc2626",
                              "& .MuiChip-icon": { color: "inherit" },
                            }}
                          />
                        </TableCell>
                        {/* Stock */}
                        <TableCell sx={{ py: 1.5, px: 2, borderBottom: "1px solid #f1f5f9" }}>
                          <Chip
                            size="small"
                            label={row.available_stock || 0}
                            sx={{
                              height: 24, fontSize: 11, fontWeight: 700, minWidth: 36,
                              bgcolor: (row.available_stock || 0) > 0 ? "#f0fdf4" : "#fef2f2",
                              color: (row.available_stock || 0) > 0 ? "#16a34a" : "#dc2626",
                            }}
                          />
                        </TableCell>
                        {/* Actions */}
                        <TableCell sx={{ py: 1.5, px: 2, borderBottom: "1px solid #f1f5f9", textAlign: "right" }}>
                          <Box sx={{ display: "flex", gap: 0.5, justifyContent: "flex-end" }}>
                            <IconButton size="small" onClick={() => navigate(`/product-history/${row.id}`)}
                              sx={{ width: 30, height: 30, borderRadius: 1.5, border: "1px solid #e2e8f0", "&:hover": { bgcolor: "#f0f9ff", borderColor: "#93c5fd" } }}>
                              <VisibilitySharpIcon sx={{ fontSize: 15, color: "#3b82f6" }} />
                            </IconButton>
                            <IconButton size="small" onClick={() => handleOpenDialog(row)}
                              sx={{ width: 30, height: 30, borderRadius: 1.5, border: "1px solid #e2e8f0", "&:hover": { bgcolor: "#f0fdf4", borderColor: "#86efac" } }}>
                              <EditSharpIcon sx={{ fontSize: 15, color: "#16a34a" }} />
                            </IconButton>
                            <IconButton size="small" onClick={() => handleOpenDeletePopup(row)}
                              sx={{ width: 30, height: 30, borderRadius: 1.5, border: "1px solid #e2e8f0", "&:hover": { bgcolor: "#fef2f2", borderColor: "#fca5a5" } }}>
                              <DeleteOutlineSharpIcon sx={{ fontSize: 15, color: "#dc2626" }} />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", px: 2, py: 2, borderTop: "1px solid #f1f5f9" }}>
            <Pagination
              count={coursings.length}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handleChangePage}
            />
          </Box>
        </Paper>

        {selectedProduct && (
          <NewPopUpProduct
            openModel={openDialog}
            handleCloseDialog={handleCloseDialog}
            data={selectedProduct}
          />
        )}
        {productToDelete && (
          <DeletePopup
            open={openDeleteProduct}
            handleCloseDelete={handleCloseDeletePopup}
            onConfirm={async () => {
              await handleDelete(productToDelete.id.toString());
            }}
            title="Delete Product"
            content={`Are you sure you want to delete "${productToDelete.productName}"?`}
          />
        )}
      </Box>
    </Box>
  );
};

export default Index;
